<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">Clientes</h4>
                <div id="botonCrearCliente">
                    <button type="button" class="btn btn-block btn-secondary col-sm-12 col-lg-2 float-right " *ngIf="botonesPermisos.crearClie" routerLink="/dashboard/crearCliente">Crear Cliente</button>
                    <!-- *ngIf="botonesPermisos.crearProd" routerLink="/dashboard/crearProducto" -->
                </div>
                <div class="table-responsive">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
                        <thead>
                            <tr style="text-align: center">
                                <th></th>
                                <!--
                                <th>Id Cliente</th>
                                -->
                                <th>RFC</th>
                                <th>Tipo cliente</th>
                                <th>Nombre/RFC</th>
                                <th>Estatus</th>
                                <th>Atendido por :</th>
                                <th>Sucursal</th>
                                <th>Fecha de registro</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let cliente of clientesArray" style="text-align: center" (click)="clienteSeleccionado(cliente.idCliente)">
                                <td>{{ cliente.id }}</td>
                                <!--
                                <td>{{ cliente.idCliente }}</td>
                                -->
                                <td>{{ cliente.rfc }}</td>
                                <td>{{ cliente.clienteEMF }}</td>
                                <td>{{ cliente.tipoCliente }}</td>
                                <td style="text-align: left"><span class="label" [style.background]="cliente.estatusColor">{{ cliente.estatusNombre }}</span></td>
                                <td>{{ cliente.atendido }}</td>
                                <td>{{ cliente.sucursal }}</td>
                                <td>{{ cliente.fechaCreacionDia }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/cliente/listar-clientes/listar-clientes.component.html